import { ShieldCheck } from "lucide-react";

export default function StatusButton({
  onClick,
  label,
  iconSize = 12,
  disabled = false,
  className = "",
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`
        inline-flex items-center gap-1
        rounded-lg border border-slate-200
        bg-slate-50 px-2.5 py-1.5
        text-[11px] font-semibold text-slate-700
        hover:bg-slate-100
        disabled:cursor-not-allowed disabled:opacity-60
        ${className}
      `}
    >
      <ShieldCheck className="w-3 h-3" />
      <span>{label}</span>
    </button>
  );
}
